<template>
  <div class="reconciliation-tab__header" data-testid="reconciliation-panel-header">
    <h2 class="reconciliation-tab__title" data-testid="reconciliation-panel-header__title">
      Reconciliation Details
    </h2>
    <v-chip
      v-if="showNoaChip"
      class="reconciliation-tab__noa-chip"
      data-testid="reconciliation-panel-header__noa-chip"
      @click="getBotRoute(task)"
    >
      <img class="" src="/img/navicon/fbc-nav/AskNoaMenu.svg" alt="" />
      Prepared by <span class="reconciliation-tab__noa-chip-text">{{ $constants.BOT_NAME }}</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'ReconciliationPanelHeader',

  props: {
    task: {
      type: Object,
      required: true,
    },
  },

  computed: {
    showNoaChip() {
      return !!(this.task?.bot_details?._id || this.task?.botid || this.task?.tmaid);
    },
  },

  methods: {
    getBotRoute(item) {
      const id = item.project;
      if (item.bot_details?.name === 'Lease Schedule') {
        this.$nova.gotoLink({ path: `/financialclose/automationlease/${id}` });
      } else if (item.bot_details?.name === 'Borrowing Schedule') {
        this.$nova.gotoLink({ path: `/financialclose/automationborrowingschedule/${id}` });
      } else if (item.bot_details?.name === 'Transaction Matching' || item.tmaid) {
        this.$nova.gotoLink({
          path: `/financialclose/automationtransactionmatching/${id}/c/${item.bot_analysis_detail?._id || item.tmaid}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/reconciliation-tab';
</style>
